import { Component, Input } from '@angular/core';
import { MasterService } from 'src/app/services/master.service';
import * as languageLibrary from '../../../services/language'
import { MessageService } from 'src/app/services/message.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'report-drop-down',
    templateUrl: './drop-down.component.html',
    styleUrl: './drop-down.component.scss',
    standalone: false
})
export class DropDownComponent {
    // Unique internal identity of the sale
    @Input() saleId: number = 0

    @Input() panel: number = 0
    
    @Input() module: number = 0
    
    private lotId = 0
    
    private lotAddress: Object | null = null
    
    // A list of available forms for the sale.
    public forms: Object[] = []
    
    // set all words
    public words = languageLibrary.language
    
    // save the language
    public language: string = 'EN'
    
    public pdf: any = null
    
    public x: number = 0;
    
    public y: number = 0;
    
    // A grouping of the existing forms suitable for display in the UI.
    public groups: Object = {}
    
    public item: any;

    get groupKeys() { return this.groups ? Object.keys(this.groups) : [] }
    public formKeys(group) { return (this.groups && this.groups[group]) ? Object.keys(this.groups[group]) : [] }
    public copies(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].copies : 0 }
    public revision(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].revision : 0 }
    public allowSetupValueChanges(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].allowSetupValueChanges : 0 }
    public setupValues(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].setupValues : 0 }
    public managed(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].managed : 0 }
    public coordinates(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0].coordinatesId : 0 }
    public form(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form][0] : 0 }
    public formOptions(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form] : 0 }
    public formOptionCount(group, form) { return (this.groups && this.groups[group] && this.groups[group][form] && this.groups[group][form].length > 0) ? this.groups[group][form].length : 0 }

    constructor(private master: MasterService, private ms: MessageService, private sanitizer: DomSanitizer) { }

    ngOnInit() {
        this.fetch()
    }

    public async fetch() {
        this.lotId = parseInt(localStorage.getItem('lot'))
        const lotState = await this.determineLotState()
        
        let saleParam = ''
        if (this.saleId > 0) {
            saleParam = `&saleId=${this.saleId}`
        }

        const res = await this.master.getAsync(`forms?lotId=${this.lotId}${saleParam}&panel=${this.panel}&module=${this.module}${lotState ? '&state=' + lotState : ''}`)

        if (!res || (res['status'] !== 200)) {
            this.ms.sendMessage("alert", { type: "danger", text: res ? res['data'].error : this.words[this.language]['apiNoResponse'] })
            return
        }

        this.forms = res.data.forms
        this.groups = this.grouped()
    }
    
    /**
     * 
     * @param group 
     * @param form 
     */
    public view = (group, form) => {
        if (!this.groups || !group || !form) {
            return
        }
        let index = 0
        if (this.formOptionCount(group, form) > 1) {
            index = document.getElementById('form-option-index')['value']
        }

        if (!this.groups[group] || !this.groups[group][form] || (this.groups[group][form].length <= 0)) {
            return
        }

        this.item = this.groups[group][form][index]

        this.download(this.item.id, form)
    }

    /**
     * Group the current forms list by category and name 
     * so they are ready for display in the UI.
     */
    public grouped = (): object => {
        const groups = {}

        if (!this.forms || (this.forms.length <= 0)) {
            return
        }

        for (const form of this.forms) {
            if (!form['category']) {
                continue
            }

            if (!groups[form['category']]) {
                groups[form['category']] = {}
            }

            if (!groups[form['category']][form['name']]) {
                groups[form['category']][form['name']] = []
            }

            const duplicate = groups[form['category']][form['name']].find(groupForm => form['id'] == groupForm['id'])
            if (duplicate) {
                continue
            }

            groups[form['category']][form['name']].push({
                id: parseInt(form['id']),       //stateFormId
                formId: parseInt(form['formId']),
                producer: form['producer'],
                copies: parseInt(form['copies']),
                selected: (groups[form['category']][form['name']].length <= 0),
                revision: form['revision'],
                allowSetupValueChanges: form['allowSetupValueChanges'],
                setupValues: form['setupValues'],
                name: form['name'],
                managed: form['managed'],
                coordinatesId: form['coordinatesId']
            })
        }

        return groups
    }
    /**
     * Query for or used cached sale lot state.
     * @returns A two-character state abbreviation for the associated sale lot
     */
    private determineLotState = async () => {
        if (!this.lotId || (this.lotId <= 0)) {
            return null
        }

        if (this.lotAddress) {
            return this.lotAddress['state']
        }

        const res = await this.master.getAsync(`lots/${this.lotId}`)
        if (!res || !res.data || !res.data['lotDetails'] || !res.data['lotDetails']['contact'] ||
            !res.data['lotDetails']['contact']['contactAddresses'] || (res.data['lotDetails']['contact']['contactAddresses'].length <= 0)) {
            return null
        }

        const addy = res.data['lotDetails']['contact']['contactAddresses'].find(addy => addy.primaryAddress == 1)
        if (!addy || !addy.state) {
            return null
        }

        this.lotAddress = addy
        return this.lotAddress['state']
    }


    /**
     * Download the given form from the API.
     * @param id Unique internal identity of the form to construct and download.
     * @param name The name of the form to download.
     */
    public download = (id: number, name: string, adjustment?) => {
        if (!this.saleId || this.saleId <= 0) {
            return
        }

        if (!id || id <= 0) {
            return
        }

        this.pdf = null
        const payload = {
            forms: [
                {
                    formId: id,
                    module: this.module,
                    copies: 1,
                    xChange: adjustment ? this.x : null,
                    yChange: adjustment ? this.y : null
                }
            ]
        }

        this.master.post(`forms?lotId=${this.lotId}&saleId=${this.saleId}`, payload, (meta) => {
            if (!meta || !meta.status || !meta.data) {
                this.ms.sendMessage("alert", { type: "danger", text: (meta && meta.error) ? meta.error : this.words[this.language]['apiNoResponse'] })
                return
            }

            const url: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(meta.data.url)
            if (!url) {
                this.ms.sendMessage("alert", { type: "danger", text: "Pdf meta data url is empty or null." })
                return
            }

            this.pdf = url

            const btn = document.getElementById('btn-view-pdf-modal-drop-down') as HTMLButtonElement
            if (!btn || adjustment) {
                return
            }

            btn.click()
        })
    }
}
